import staked from './staked-dapp/metainfo';
import coinbaseStaking from './coinbase-staking/metainfo';
export default {
  staked,
  coinbaseStaking
};
